import PublishRouter from "@/router/routerMap/PublishRouter";
import SendRouter from "@/router/routerMap/SendRouter";
import { RouteRecordRaw } from "vue-router";
import SpSquareRouter from "@/router/routerMap/SpSquareRouter";
import ISVRouter from "@/router/routerMap/ISVRouter";

export default [
  ...PublishRouter,
  ...SendRouter,
  ...SpSquareRouter,
  ...ISVRouter,
] as Array<RouteRecordRaw>;
